(function () {
  const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

  function loadStylesheet(href) {
    if (document.querySelector(`link[href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function loadScript(src) {
    return new Promise((resolve, reject) => {
      if (window.Swiper) {
        resolve();
        return;
      }

      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing) {
        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function initSection(section) {
    const swiperEl = section.querySelector('.terra-real-results__swiper');
    if (!swiperEl || swiperEl.dataset.initialized === 'true') return;

    const prevEl = section.querySelector('.terra-real-results__arrow--prev');
    const nextEl = section.querySelector('.terra-real-results__arrow--next');
    const slidesMobile = Number(section.dataset.slidesMobile || 3);
    const slidesDesktop = section.dataset.slidesDesktop || 'auto';

    const config = {
      spaceBetween: 8,
      slidesPerView: slidesMobile,
      watchOverflow: true,
      navigation: {
        prevEl,
        nextEl,
      },
      breakpoints: {
        750: {
          slidesPerView: slidesDesktop === 'auto' ? 'auto' : Number(slidesDesktop),
          spaceBetween: 8,
        },
      },
    };

    new window.Swiper(swiperEl, config);
    swiperEl.dataset.initialized = 'true';
  }

  function initAll(root) {
    loadStylesheet(SWIPER_CSS);
    loadScript(SWIPER_JS)
      .then(() => {
        (root || document).querySelectorAll('.terra-real-results').forEach(initSection);
      })
      .catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.terra-real-results')) {
      initAll(event.target);
    }
  });
})();
